import { Day } from '@model/day';
import {Spent} from '@model/spent';
import {Supply} from '@model/supply';
import {Payment} from '@model/payment';
import {Treasury} from '@model/treasury';
import {FormGroup} from '@angular/forms';
import * as Highcharts from 'highcharts';
import { Globals } from '@theme/utils/globals';
import {FundRequest} from '@model/fund-request';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { DayService } from '@service/day/day.service';
import {PaymentFunding} from '@model/payment-funding';
import {PaymentCustomer} from '@model/payment-customer';
import HC_drilldown from 'highcharts/modules/drilldown';
import { ActivatedRoute, Router } from '@angular/router';
import {PaymentRepayment} from '@model/payment-repayment';
import { SpentService } from '@service/spent/spent.service';
import { SupplyService } from '@service/supply/supply.service';
import { FilterService } from '@service/filter/filter.service';
import {PaymentService} from '@service/payment/payment.service';
import {TreasuryService} from '@service/treasury/treasury.service';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FundRequestService} from '@service/fund-request/fund-request.service';
import { ConfirmationService } from '@service/confirmation/confirmation.service';
import { DayAddComponent } from '@agence/tresorerie/day/day-add/day-add.component';
import {PaymentFundingService} from '@service/payment-funding/payment-funding.service';
import {PaymentAddComponent} from '@locataire/payment/payment-add/payment-add.component';
import { SpentAddComponent} from '@agence/tresorerie/spent/spent-add/spent-add.component';
import {PaymentCustomerService} from '@service/payment-customer/payment-customer.service';
import {PaymentRepaymentService} from '@service/payment-repayment/payment-repayment.service';
import { SupplyAddComponent} from '@agence/tresorerie/supply/supply-add/supply-add.component';
import {TreasuryAddComponent} from '@agence/tresorerie/treasury/treasury-add/treasury-add.component';
import {PaymentCustomerAddComponent} from '@client/payment/payment-customer-add/payment-customer-add.component';
import { PaymentFundingAddComponent } from '@chantier/payment/payment-funding-add/payment-funding-add.component';
import { ConfirmationAddComponent } from '@agence/tresorerie/confirmation/confirmation-add/confirmation-add.component';
import { PaymentRepaymentAddComponent } from '@agence/proprietaire/payment/payment-repayment-add/payment-repayment-add.component';
import { NgxPermissionsService } from 'ngx-permissions';
import { ImportationComponent } from '@agence/modal/importation/Importation.component';
import { CookieService } from 'ngx-cookie-service';
import { OnBoardingService } from '@theme/utils/on-boarding.service';
import { TrusteeSpentAddComponent } from '@agence/tresorerie/spent/trustee-spent-add/trustee-spent-add.component';
import { SyndicService } from '@service/syndic/syndic.service';
import { TrusteeProviderPaymentAddComponent } from '@agence/locataire/payment/trustee-provider-payment-add/trustee-provider-payment-add.component';
import { TrusteeSupplyAddComponent } from '@agence/tresorerie/supply/trustee-supply-add/trustee-supply-add.component';
import { InvoicePaymentService } from '@service/invoice-payment/invoice-payment.service';
import { FundsPaymentService } from '@service/syndic/funds-payment.service';
HC_drilldown(Highcharts);

@Component({
  selector: 'app-trustee-treasury-show',
  templateUrl: './trustee-treasury-show.component.html',
  styleUrls: ['./trustee-treasury-show.component.scss']
})
export class TrusteeTreasuryShowComponent implements OnInit {

  //variable du graph
  public Highcharts = Highcharts;
  public barBasicChartOptions: any

  pieDem = 0
  pieDep = 0
  pieRev= 0
  piePay= 0
  piePayCus = 0
  piePayFun = 0
  pieApp = 0
  pieFPay = 0
  pieFP = 0
  pieFPR = 0

  widget = []
  mtnDem= []
  mtnDep= []
  mtnPayt = []
  mtnPaytC = []
  mtnPaytF = []
  mtnSupp = []
  mtnRever = []
  mtnFPay = []
  mtnFP = []
  mtnFPR = []
  mois = []
  form: FormGroup;
  filtre: boolean = false;
  verif: boolean = false;
  button: boolean = false;
  tresorerie: boolean = false;
  isHidden: boolean = false;
  treasury: Treasury;
  supplies: Supply[];
  funds: FundRequest[];
  days: Day[];
  spents: Spent[];
  payments: Payment[];
  visible: boolean = false;
  visibilite: boolean = false;
  paymentsRepayment: PaymentRepayment[];
  paymentsCustomer: PaymentCustomer[];
  paymentsFunding: PaymentFunding[];
  type: string = 'TRESORERIE';
  global = {country: Globals.country, device: Globals.device}
  userSession = Globals.user
  filter: any;
  etatRow = [
    { label: 'Actif', value: 'ACTIF' },
    { label: 'Inactif', value: 'INACTIF' }
  ]
  typeRow = [
    {label: 'Trésorérie de bord', value: 'TRESORERIE'},
    // {label: 'DEMANDE', value: 'DEMANDE'},
    {label: 'Depense', value: 'DEPENSE'},
    {label: 'Paiement appel de charges', value: 'FUNDS_PAYMENT'},
    {label: 'Paiement tiers', value: 'TIERS'},
    {label: 'Approvisionnement', value: 'APPROVISIONNEMENT'}
  ];
  categorieRow = [
    {label: 'En location', value: 'LOCATION'},
    {label: 'En vente', value: 'VENTE'}
  ];
  event = {
    categorie: null,
    code: null,
    count: 10,
    create: null,
    dateD: null,
    dateF: null,
    etat: null,
    max: null,
    min: null,
    name: null,
    ordre: "ASC",
    type: "TRESORERIE",
    uuid: null
  }
  minTitle: string = "Montant MIN"
  userTitle: string = "Crée par"
  maxTitle: string = "Montant MAX"
  nameTitle: string = "Nom / Libellé"
  name: boolean = true
  etatTitle: string = "Disponibilité ?"
  categorieTitle: string = "Type de bien"
  cookie: string = ''
  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 8000,
    timerProgressBar: true
  })

  public pieChartData: any;
  @ViewChild('doughnutChart', {static: false}) doughnutChart: ElementRef; // doughnut
  public pieChartTag: CanvasRenderingContext2D;

  transactions: any[] = []
  paymentsTiers: any[] = [];
  fundsPayments: any[] = [];

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private dayService: DayService,
    private modalService: NgbModal,
    private spentService: SpentService,
    private supplyService: SupplyService,
    private filterService: FilterService,
    public boarding: OnBoardingService,
    private cookieService: CookieService,
    private paymentService: PaymentService,
    private treasuryService: TreasuryService,
    private fundRequestService: FundRequestService,
    private confirmationService: ConfirmationService,
    private permissionsService: NgxPermissionsService,
    private paymentFundingService: PaymentFundingService,
    private paymentCustomerService: PaymentCustomerService,
    private paymentRepaymentService: PaymentRepaymentService,
    private syndicService: SyndicService,
    private invoicePaymentService: InvoicePaymentService,
    private fundsPaymentService: FundsPaymentService
  ) {
    this.verif = this.treasuryService?.day
    this.onChangeLoad(this.type);
    this.onFilter(this.event);
    const permission = JSON.parse(localStorage.getItem('permission-zen')) ? JSON.parse(localStorage.getItem('permission-zen')) : [];
    this.permissionsService.loadPermissions(permission);
  }

  ngOnInit(): void {
    this.getGraph();
    this.getPie();
    this.filterService.dashboard(this.event, 'treasury', this.route.snapshot.params.id).subscribe(
      res => {
        this.getGraph();
        this.getPie();
        this.onSet(res);
    }, err => {})
  }
  ngAfterViewInit(): void {
    this.cookie = this.cookieService.get('treasury-show');
    var etat = this.cookie ? true : false;
    if(this.cookie !== 'on-boarding-treasury-show') {
      this.boarding.treasuryShow(etat);
    }
    this.boarding.treasuryShow(etat);
  }

  onFilter($event) {
    this.filterService.type = this.type;
    this.filter = null
    if($event.type !== 'TRESORERIE'){
      this.filterService.search($event, 'treasury', this.route.snapshot.params.id).subscribe(
        res => {
        this.filter = this.filterService.filter
        if($event.type === 'LOCATAIRE'){
          return this.payments = res;
        } else if($event.type === 'CLIENT'){
          return this.paymentsCustomer = res;
        } else if($event.type === 'APPROVISIONNEMENT'){
          return this.supplies = res;
        } else if($event.type === 'JOURNEE'){
          return this.days = res;
        } else if($event.type === 'DEMANDE'){
          return this.funds = res;
        }else if($event.type === 'DEPENSE'){
          return this.spents = res;
        }else if($event.type === 'FINANCEMENT'){
          return this.paymentsFunding = res;
        }else if($event.type === 'REVERSEMENT'){
          return this.paymentsRepayment = res;
        } else if ($event.type === "FUNDS_PAYMENT") {
          return this.fundsPayments = res;
        }else if ($event.type === "TIERS") {
          return this.paymentsTiers = res;
        }
      }, err => { })
    } else{
      this.filterService.dashboard($event, 'treasury', this.route.snapshot.params.id).subscribe(
        res => {
          this.onSet(res);
      }, err => { })
    }
  }
  onSet(res){
    if (res) {
      this.widget = res?.widget
      this.getGraph();
      this.getPie();
      this.mtnDem = []
      this.mtnDep = []
      this.mtnRever = []
      this.mtnPayt = []
      this.mtnPaytC = []
      this.mtnPaytF = []
      this.mtnSupp = []
      this.mtnFPay = []
      this.mtnFP = []
      this.mtnFPR = []
      this.mois = []
      res?.graph.forEach(el => {
        this.mtnDem.push(el?.dem)
        this.mtnDep.push(el?.dep)
        this.mtnRever.push(el?.rever)
        this.mtnPayt.push(el?.pay)
        this.mtnPaytC.push(el?.payC)
        this.mtnPaytF.push(el?.payF)
        this.mtnSupp.push(el?.supp)
        this.mtnFPay.push(el?.fPay)
        this.mtnFP.push(el?.payFP)
        this.mtnFPR.push(el?.payFPR)
        this.mois.push(el?.date)
      });

      this.pieDem = res?.pie?.nbrDem
      this.pieDep = res?.pie?.nbrDep
      this.pieRev = res?.pie?.nbrR
      this.piePay = res?.pie?.nbrP
      this.piePayCus = res?.pie?.nbrPc
      this.piePayFun = res?.pie?.nbrPf
      this.pieApp = res?.pie?.nbrA
      this.pieFPay = res?.pie?.nbrFp
      this.pieFP = res?.pie?.nbrFP
      this.pieFPR = res?.pie?.nbrFPR
    }
  }
  onChangeLoad($event) {
    this.type = $event
    if ($event === 'TRESORERIE'){
      if(!this.treasury){
        this.treasuryService.getSingle(this.route.snapshot.params.id).subscribe((res: any) => {
          if (res) {
            return this.treasury = res;
          }
        });
      }
      this.nameTitle = 'Nom'
      this.name = false
      this.categorieTitle = 'Type trésorerie'
      this.etatRow = [];
      this.categorieRow = [];
      this.visible = true;
      this.visibilite = true;
    } else if ($event === 'DEMANDE'){
      this.fundRequestService.getList(this.treasury.uuid, 'TRANSMIS').subscribe((res) => {
        return this.funds = res;
        }, error => {}
      );
      this.nameTitle = 'Trésorerie'
      this.name = false
      this.etatRow = [
        {label: 'Attente', value: 'ATTENTE'},
        {label: 'Décaissé', value: 'DECAISSE'}
      ];
      this.categorieRow = [];
      this.visible = false;
      this.visibilite = false;
    } else if ($event === 'DEPENSE'){
      this.spentService.getList(this.treasury.uuid).subscribe((res) => {return this.spents = res; }, error => {});
      this.nameTitle = 'Trésorerie'
      this.categorieTitle = 'Statut'
      this.etatTitle = 'État'
      this.name = false
      this.etatRow = [
        {label: 'Attente', value: 'ATTENTE'},
        {label: 'Valider', value: 'VALIDER'}
      ];
      this.categorieRow = [
        {label: 'Attente', value: 'ATTENTE'},
        {label: 'Confirmer', value: 'CONFIRMER'}
      ];
      this.visible = true;
      this.visibilite = false;
    } else if($event === 'APPROVISIONNEMENT'){
      this.supplyService.getList(this.treasury.uuid).subscribe((res) => {
        return this.supplies = res;
        }, error => {}
      );
      this.nameTitle = 'Trésorerie'
      this.categorieTitle = 'Type trésorerie'
      this.etatRow = [];
      this.categorieRow = [];
      this.visible = false;
      this.visibilite = false;
    } else if($event === 'FUNDS_PAYMENT') {
      this.fundsPaymentService.getList(null, null, this.treasury?.uuid).subscribe((res) => {
        return this.fundsPayments = res;
        }, error => {}
      );
      this.name = true
      this.nameTitle = 'Copropriétaire'
      this.categorieTitle = 'Type'
      this.categorieRow = [
        {label: 'Appel de charges', value: 'APPEL_FONDS'}
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ];
      this.visible = false;
      this.visibilite = false;
    } else if($event === 'TIERS') {
      this.invoicePaymentService.getList(null, null, this.treasury?.uuid).subscribe((res) => {
        console.log(res)
        return this.paymentsTiers = res;
        }, error => {}
      );
      this.name = true
      this.nameTitle = 'Tiers'
      this.categorieTitle = 'Type'
      this.categorieRow = [
        {label: 'Facture', value: 'INVOICE_CO'}
      ];
      this.etatTitle = 'État'
      this.etatRow = [
        {label: 'Valide', value: 'VALIDE'},
        {label: 'Invalide', value: 'INVALIDE'}
      ];
      this.visible = false;
      this.visibilite = false;
    }
  }
  onPrinter() {
    if (this.type === 'DEMANDE') {
      this.fundRequestService.getPrinter('LISTE', this.userSession?.agencyKey, this.userSession?.uuid, this.filter);
    } else if(this.type === 'DEPENSE') {
      this.spentService.getPrinter('LISTE', this.userSession?.agencyKey, this.userSession?.uuid, this.filter, this.treasury?.uuid);
    } else if(this.type === 'APPROVISIONNEMENT') {
      this.supplyService.getPrinter('LISTE', this.userSession?.agencyKey, this.userSession?.uuid, this.filter);
    } else if(this.type === 'FUNDS_PAYMENT') {

    } else if(this.type === 'TIERS') {

    }
  }
  onModel() {
    if (this.type === 'DEMANDE') {
      this.fundRequestService.getGenerer();
    } else if(this.type === 'APPROVISIONNEMENT') {
      this.supplyService.getGenerer();
    } else if(this.type === 'FUNDS_PAYMENT') {

    } else if(this.type === 'TIERS') {

    }
  }
  onExport() {
    if (this.type === 'DEMANDE') {
      this.fundRequestService.getExport(this.userSession?.agencyKey, this.userSession?.uuid, this.filter);
    } else if(this.type === 'DEPENSE') {
      this.spentService.getExport(this.userSession?.agencyKey, this.userSession?.uuid, this.filter);
    } else if(this.type === 'APPROVISIONNEMENT') {
      this.supplyService.getExport(this.userSession?.agencyKey, this.userSession?.uuid, this.filter);
    } else if(this.type === 'FUNDS_PAYMENT') {

    } else if(this.type === 'TIERS') {

    }
  }
  onImport(){
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(ImportationComponent);
    modalRef.componentInstance.type = this.type;
  }
  addPayementTenant(treasury) {
    this.modalService.dismissAll();
    this.paymentService.edit = false;
    this.paymentService.treasury = treasury;
    this.modal(PaymentAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  addSpent(treasury) {
    this.modalService.dismissAll();
    this.spentService.edit = false;
    this.spentService.treasury = treasury;
    this.syndicService.syndic = this.treasury.trustee.uuid
    this.modal(TrusteeSpentAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  addSupply(treasury) {
    this.modalService.dismissAll();
    this.supplyService.edit = false;
    this.supplyService.treasury = treasury;
    this.modal(TrusteeSupplyAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  addPayementRepayment(treasury) {
    this.modalService.dismissAll();
    this.paymentRepaymentService.edit = false;
    this.paymentRepaymentService.treasury = treasury;
    this.modal(PaymentRepaymentAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  addConfirmation(treasury) {
    this.modalService.dismissAll();
    this.confirmationService.edit = false;
    this.confirmationService.treasury = treasury;
    this.modal(ConfirmationAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }
  editTreasury() {
    this.treasuryService.setTreasury(this.treasury);
    this.treasuryService.edit = true;
    this.modal(TreasuryAddComponent, 'modal-basic-title', 'lg', true, 'static');
  }
  getGraph () {
    this.barBasicChartOptions = {
      chart: {
        type: 'column'
      },
      colors: ['#b3e0ff', '#FF5733', '#2ABF0F', 'red', 'yellow', '#D63FF7', 'gray'],
      title: {
        text: 'Diagramme en bande des transactions'
      },
      xAxis: {
        categories: (this.mois),
        crosshair: true
      },
      credits: {
        enabled: false
      },
      yAxis: {
        title: {
          text: this.global.device
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [
        // {
        //   color: '#b3e0ff',
        //   name: 'Demande',
        //   data: this.mtnDem
        // },
        {
          color: 'gray',
          name: 'Approvisionnement',
          data: this.mtnSupp

        },
        {
          color: '#FF5733',
          name: 'Dépense',
          data: this.mtnDep

        },{
          color: '#2ABF0F',
          name: 'Appel de charges',
          data: this.mtnFP
        }, {
          color: 'red',
          name: 'Fonds de réserve',
          data: this.mtnFPR
        }, {
          color: '#D63FF7',
          name: 'Paiement fournisseurs',
          data: this.mtnPaytF
        },
      ]
    };
  }
  getPie(){
    setTimeout(() => {
      /* pie cart */
      const pieTag = (((this.doughnutChart?.nativeElement as HTMLCanvasElement)?.children));
      this.pieChartTag = ((pieTag['doughnut_chart'])?.lastChild).getContext('2d'); // doughnut_chart
      this.pieChartData = {
        // labels: ["Demande", "Approvisionnement", "Dépense", 'Appel de charges', "Fonds de réserve", "Paiement fournisseurs"],
        labels: ["Approvisionnement", "Dépense", 'Appel de charges', "Fonds de réserve", "Paiement fournisseurs"],
        datasets: [{
          // data: [this.pieDem, this.pieApp, this.pieDep, this.piePay, this.piePayCus, this.piePayFun],
          data: [this.pieApp, this.pieDep, this.pieFP, this.pieFPR, this.piePayFun],
          // backgroundColor: ['#b3e0ff', 'gray', '#FF5733', '#2ABF0F', '#FF0000', '#D63FF7', '#FFFF00', '#808080'],
          backgroundColor: ['gray', '#FF5733', '#2ABF0F', '#FF0000', '#D63FF7', '#FFFF00', '#808080'],
          // hoverBackgroundColor: ['#b3e0ff', 'gray', '#FF5733', '#2ABF0F', '#FF0000', '#D63FF7', '#FFFF00', '#808080']
          hoverBackgroundColor: ['gray', '#FF5733', '#2ABF0F', '#FF0000', '#D63FF7', '#FFFF00', '#808080']
        }]
      };
    });
  }

  addPayementCoOwner(treasury) {
    this.modalService.dismissAll();
    this.paymentService.treasury = treasury;
    // this.paymentService.edit = false;
    // this.modal(TrusteePaymentAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }

  addPayementTiers(treasury) {
    this.modalService.dismissAll();
    this.invoicePaymentService.treasury = treasury;
    this.invoicePaymentService.edit = false;
    this.modal(TrusteeProviderPaymentAddComponent, 'modal-basic-title', 'xl', true, 'static');
  }

  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        Swal.fire('', 'Enrégistrement supprimé avec succès !', 'success');
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => {}, (reason) => { });
  }
  back(){ this.router.navigate(['/admin/tresorerie']) }
}
